import { EmployeeDiscount } from './../models/employee-discount';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class AlgScontoService {

  public completed = new BehaviorSubject(null);
  public currentEmployee: Observable<EmployeeDiscount>;
  private CurrentEmployeeSubject: BehaviorSubject<EmployeeDiscount> = new BehaviorSubject<EmployeeDiscount>({} as EmployeeDiscount);

  sendResult(data) {
    this.completed.next(data);
  }

  constructor() {     
    this.completed.next(false);
    this.currentEmployee = this.CurrentEmployeeSubject.map(emp => ({...emp}));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/alg-sconto.service.ts